import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router';

export function ForbiddenPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={1.5}
      px={2}
      textAlign="center"
    >
      <Typography variant="h2" fontWeight={700} color="primary.main">
        403
      </Typography>
      <Typography variant="h6">Access denied</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={360}>
        You don&apos;t have permission to view this page. Contact an administrator if you believe this is a mistake.
      </Typography>
      <Button component={RouterLink} to="/dashboard" variant="contained" sx={{ mt: 2 }}>
        Back to dashboard
      </Button>
    </Box>
  );
}
